import React from 'react';
import { Loader2 } from 'lucide-react';

const PageLoader = ({ darkMode, message = 'Loading...' }) => {
  return (
    <div className={`flex flex-col items-center justify-center min-h-[400px] ${darkMode ? 'bg-gray-900' : 'bg-gray-50'}`}>
      <Loader2
        className={`animate-spin mb-4 ${darkMode ? 'text-blue-400' : 'text-blue-600'}`}
        size={48}
      />
      <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
        {message}
      </p>
    </div>
  );
};

export default PageLoader;
